import { api } from '../../../api/index';
import { actions } from '../../../../store/actions/index';

export const addDeliveryZone = ({ ...data }) => async dispatch => {
  try {
    await api.addDeliveryZone(data);
    dispatch(actions.closeModal.act('addZone'));
    dispatch(actions.needToUpdateData.act(true));
  } catch (e) {
    return e;
  }
};
